import { Debt } from '../../interfaces';
import { isEligible } from './isEligible';

export const getEligibleDebts = (debts: Debt[]): Debt[] => {
  const eligibleDebts = debts.filter((debt) => isEligible(debt));

  return eligibleDebts;
};
